module.exports = __webpack_public_path__ + "static/Calibre-Light-73b7f4385ae2f8028e1b365a48038582.ttf";